module.exports = "/assets/data/5b418ba7810a2893371dce8d164f858f-EC1M.data.json";